import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { RootState } from 'src/reducers/RootReducer';
import Project from 'src/entities/Project';
import { changeProjectData, ChangeProjectDataAction } from 'src/actions/project/change-data/ChangeProjectData.actions';
import ProjectRoundInformationFormComponent, { ProjectRoundInformationFormComponentProps }
from 'src/modules/project/update/partials/ProjectRoundInformationForm.component';
import ProjectImage from 'src/entities/ProjectImage';
import Base64Encoder from 'src/services/encoders/Base64Encoder';
import {
  updateProject,
  UpdateProjectAction,
  UpdateProjectSuccess
} from 'src/actions/project/update/UpdateProject.actions';
import * as updateProjectTypes from 'src/actions/project/update/Types';
import LoadingContainer from 'src/modules/commons/loading/Loading.container';
import ProjectData from 'src/value-objects/ProjectData';
import { UpdateCompanyAction, updateCompanyClearErrors } from 'src/actions/company/update/UpdateCompany.actions';
import { getProject, GetProjectAction } from 'src/actions/project/get/GetProject.actions';

interface StateProps {
  formData?: ProjectData;
  error: boolean;
  errorMessage: {};
}

interface DispatchProps {
  updateCompanyClearErrors(): UpdateCompanyAction;

  changeProjectData(project: ProjectData): ChangeProjectDataAction;

  updateProject(project: ProjectData): Promise<UpdateProjectAction>;

  getProject(projectId: number): Promise<GetProjectAction>;
}

interface OwnProps {
  project: Project;
}

interface Props extends StateProps, DispatchProps, OwnProps {

}

interface State {
  success?: boolean;
  section: string;
}

class ProjectRoundInformationFormContainer extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);
    this.state = {
      section: 'resumen'
    };
    this.props.updateCompanyClearErrors();
  }

  public componentWillMount(): void {
    this.setState(
      {success: false}
    );
  }

  public render(): React.ReactNode {
    return (
      this.props.project && this.props.formData ?
        <ProjectRoundInformationFormComponent {...this.getComponentProps()} /> :
        <LoadingContainer/>
    );
  }

  private changeSection(value: string): void {
    this.setState({section: value});
    this.setState({success: false});
  }

  private handleRichEditor(key: string): (html: string) => void {
    return (
        (html: string) => {
          let newData = {...this.props.formData!, [key]: html};
          this.props.changeProjectData(new ProjectData(newData));
        }
    );
  }

  private handleChange(key: string): (value: string | boolean | File) => void {
    switch (key) {
      case 'projectImages':
        return (
          (value: File) => {
              Base64Encoder.encode(value).then((result) => {
                let newImage = new ProjectImage({
                  url: URL.createObjectURL(value),
                  encoded: result.split('base64,')[1],
                  ext: value.type.split('/')[1],
                  name: value.name
                });
                let newData = this.props.formData!;
                newData.images = [newImage].concat(newData.images);
                this.props.changeProjectData(new ProjectData(newData));
              });
          }
        );
      case 'environmentImage':
        return (
          (value: File) => {
            Base64Encoder.encode(value).then((result) => {
              let newImage = new ProjectImage({
                url: URL.createObjectURL(value),
                encoded: result.split('base64,')[1],
                ext: value.type.split('/')[1],
                name: value.name
              });
              let newData = this.props.formData!;
              newData.environmentImage = newImage;
              this.props.changeProjectData(new ProjectData(newData));
            });
          }
        );
      case 'goToMarketImage':
        return (
          (value: File) => {
            Base64Encoder.encode(value).then((result) => {
              let newImage = new ProjectImage({
                url: URL.createObjectURL(value),
                encoded: result.split('base64,')[1],
                ext: value.type.split('/')[1],
                name: value.name
              });
              let newData = this.props.formData!;
              newData.goToMarketImage = newImage;
              this.props.changeProjectData(new ProjectData(newData));
            });
          }
        );
      case 'highlightInvestorImage':
        return (
          (value: File) => {
            Base64Encoder.encode(value).then((result) => {
              let newImage = new ProjectImage({
                url: URL.createObjectURL(value),
                encoded: result.split('base64,')[1],
                ext: value.type.split('/')[1],
                name: value.name
              });
              let newData = this.props.formData!;
              newData.highlightInvestorImage = newImage;
              this.props.changeProjectData(new ProjectData(newData));
            });
          }
        );
      default:
        return (
          (value: string | boolean) => {
            let newData = {...this.props.formData!, [key]: value};
            this.props.changeProjectData(new ProjectData(newData));
          }
        );
    }
  }

  private handleSubmit(): void {
    this.props.updateProject(this.props.formData!).then((response: UpdateProjectSuccess) => {
      if (response.type === updateProjectTypes.UPDATE_PROJECT_SUCCESS) {
        this.setState(
          {success: true}
        );
      }
    });
  }

  private getComponentProps(): ProjectRoundInformationFormComponentProps {
    return {
      handleClick: (value: string) => this.changeSection(value),
      handleChange: (key: string) => this.handleChange(key),
      handleSubmit: () => this.handleSubmit(),
      handleRichEditor: (key: string) => this.handleRichEditor(key),
      formData: this.props.formData!,
      error: this.props.error,
      errorMessage: this.props.errorMessage,
      success: this.state.success!,
      section: this.state.section
    };
  }
}

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>): DispatchProps => ({
  changeProjectData: (project: ProjectData): ChangeProjectDataAction => (
    dispatch(changeProjectData(project))
  ),
  updateProject: (project: ProjectData): Promise<UpdateProjectAction> => (
    dispatch(updateProject(project))
  ),
  getProject: (projectId: number): Promise<GetProjectAction> => (
    dispatch(getProject(projectId))
  ),
  updateCompanyClearErrors: (): UpdateCompanyAction => {
    return dispatch(updateCompanyClearErrors());
  }
});

const mapStateToProps: (state: RootState) => StateProps = (state: RootState): StateProps => ({
  formData: state.changeProjectData.project,
  error: state.getProject.error,
  errorMessage: state.getProject.errorMessage,
});

export default connect(mapStateToProps, mapDispatchToProps)(ProjectRoundInformationFormContainer);



// WEBPACK FOOTER //
// ./src/modules/project/update/partials/ProjectRoundInformationForm.container.tsx